import React, { useEffect, useState } from "react";
// import './TestCr.css';
import "./TestCr.css";
// import { FAQ } from '../Covid19/Data/FAQData'
import FAQstructure from "./FAQstructure";

const FAQ = [
  {
    id: 1,
    title: "What is an X-ray? ",
    desc:
      "An X-ray is a fast and painless test which involves generating the images of your body structures specifically your bones. It utilizes a small amount of ionizing radiation and is the frequently used form for clinical imaging. X-rays are useful for diagnosing the fractured bones, detects any internal injury and infections like pneumonia, arthritis etc. You should reach out to the Redcliffe Labs to get your X-ray done. We have the most skilled and professional radiologic technologists who ensure performing the examination appropriately and precisely.",
  },
  {
    id: 2,
    title: " What is a CT scan?",
    desc:
      "A Computerized tomography or CT scan is a clinical imaging method used in radiology for getting comprehensive body images for the purpose of diagnosis. Redcliffe Labs have incorporated the use of special equipment with the sophisticated computers for generating images of the complete body.",
  },
  {
    id: 3,
    title:
      "What can you expect while getting your X-ray or any imaging exam done with Redcliffe Labs?",
    desc:
      "Redcliffe Labs have integrated the trained and licensed radiology technologists to perform the radiology examination. According to the exam type, you may be required to lie down, be seated, or stand. There will be the use of an imaging plate for obtaining the image. For better positioning, technologists may involve using the devices which would help you with maintaining the right position. To protect you from radiation, the technologist will be placing the apron over your chest area, pelvic area, and thyroid. You need to hold your breath as well at some points during the process for reducing the probability of blurred images. The technologist will take multiple images from varied angles and you may be asked for the repositioning of different views. ",
  },
  {
    id: 4,
    title:
      "Why do you require a physician’s instruction for an X-ray or other imaging services exam?",
    desc:
      "As per the law, it is crucial to hold the written instruction for any kind of imaging exam. Patients must be assessed only after the physician examination to move forward with the imaging of body parts adequately.",
  },
  {
    id: 5,
    title: "Why can’t you eat or drink anything before any imaging exam?",
    desc:
      "Patients can eat or drink something light for general imaging such as chest, feet, spine and hands. But for other imaging processes patients are asked not to eat or drink. It is for this reason that technologists can perform the best exam on an empty stomach.",
  },
  {
    id: 6,
    title: "How much time does it take for imaging exams?",
    desc:
      "The time limit for every imaging exam is different so here it is: Ultrasound- 30 minutes- 60 minutes, MRI- 15-90 minutes, Mammogram-15 minutes, PET-1-3 hours, CT- 10-30 minutes",
  },
  {
    id: 7,
    title: "What imaging exams are offered by Redcliffe Labs?",
    desc:
      "The imaging solutions that we are providing at Redcliffe Labs includes X-ray, MRI scan, PET scan, mammography, ultrasound, and CT scan. ",
  },
];



const FAQforhomepage = ({ faq }) => {
  const [width, setWidth] = useState("");
  useEffect(() => {
    setWidth(window.screen.width);
  }, []);
  
  return (
    <React.Fragment>
      <div className="accordionNew" id="faq">
        <h2 className="h1style">
          {width > 780 ? " Frequently Asked Questions" : "FAQs"}
        </h2>

        {faq && faq != undefined && faq !== ""
          ? faq.map((value, index) => (
              <div key={value.id}>
                <FAQstructure value={value} indek={index} />
              </div>
            ))
          : FAQ.map((value, index) => (
              <div key={value.id}>
                <FAQstructure value={value} />
              </div>
            ))}
      </div>
    </React.Fragment>
  );
};

export default FAQforhomepage;
